import React from "react";
import './CallToAction.scss';

const CallToAction = ({ url, linkText }) => (
    <a href={url}>
        <div className="CallToAction__button">{linkText}</div>
    </a>
)

export default CallToAction;